import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';

export class KalenderMitarbeiter {
  constructor({
    id,
    vorname,
    nachname,
    beruf,
    stationen,
    imgUrl,
    lehrjahr,
  }: {
    id: string;
    vorname: string;
    nachname: string;
    beruf: Beruf;
    stationen?: ArbeitsbereichStation[];
    imgUrl?: string;
    lehrjahr: string;
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
    this.beruf = beruf;
    this.stationen = stationen;
    this.imgUrl = imgUrl;
    this.lehrjahr = lehrjahr;
  }

  id: string;
  vorname: string;
  nachname: string;
  beruf: Beruf;
  stationen?: ArbeitsbereichStation[];
  lehrjahr: string;
  imgUrl?: string;
}
